import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    this.collator = new Intl.Collator();
  }

  /*
   * Reordena los items del controlador dentro del elemento que los
   * contenga.
   */
  sort({ params: { direction, field } }) {
    this.itemTargets
      .sort((a, b) => {
        const [first, second] = direction == "desc" ? [b, a] : [a, b];

        return this.collator.compare(
          first.dataset[field],
          second.dataset[field]
        );
      })
      .forEach((x) => x.parentNode.appendChild(x));
  }
}
